module.exports = __webpack_public_path__ + "img/atomic_01.8b910357.png";